import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IPrivateBookmark, privateBookmarksManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const PRIVATE_BOOKMARK_MODULE = 'privateBookmarkModule';

const dataObjectModule = getDataObjectsModule<IPrivateBookmark>(privateBookmarksManager, 5);
const searchModule = getSearchModule();

const privateBookmarkModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(PRIVATE_BOOKMARK_MODULE, privateBookmarkModuleInstance);

export { PRIVATE_BOOKMARK_MODULE };
